import { WithGuideLink } from '@mews-commander/types';
import { Stack } from '@optimus-web/core';
import { GuideLinkButton } from '../navigation';
import { ModalWrapper, NewModalBodyWrapper } from './ModalWrapper';

export const PortfolioLayout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => (
    <ModalWrapper>
        <NewModalBodyWrapper padded>
            <Stack spacing="200" vertical>
                {children}
            </Stack>
        </NewModalBodyWrapper>
    </ModalWrapper>
);

export const PortfolioLayoutHeader: React.FC<
    React.PropsWithChildren<Partial<WithGuideLink> & { title: React.ReactNode; rightSide?: React.ReactNode }>
> = ({ title, rightSide, guideLink, children }) => (
    <Stack vertical spacing="100">
        <Stack distribution="space-between" wrap>
            {title}
            <Stack spacing="100">
                {rightSide}
                {guideLink ? <GuideLinkButton guideLink={guideLink} /> : null}
            </Stack>
        </Stack>
        {children}
    </Stack>
);
